import { Dispatch, SetStateAction, useCallback } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { getInitialStoreDefaultSchedule } from 'reducks/storeDefault/operations'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useToggleScheduleType = (
  storeDefaultBreadRef: FirebaseDocRefType,
  openDeleteScheduleCautionModal: (type: StockUnionType) => void,
  setSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setIsType: Dispatch<SetStateAction<boolean>>,
  type: StockUnionType
): (() => void) => {
  return useCallback(() => {
    setIsType((prevState) => {
      if (prevState) {
        openDeleteScheduleCautionModal(type)
        return true
      } else {
        const scheduleRef = storeDefaultBreadRef.parent.parent?.collection('store_default_schedules').doc()
        if (!scheduleRef) return prevState
        setSchedules([getInitialStoreDefaultSchedule(storeDefaultBreadRef, scheduleRef, type)])
        return !prevState
      }
    })
  }, [storeDefaultBreadRef, openDeleteScheduleCautionModal, setSchedules, setIsType, type])
}

export default useToggleScheduleType
